import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './DocumentationButton.styles'
import Button from '@material-ui/core/Button'
import { FormattedMessage } from 'react-intl'
import LINKS from '../../../App.const'
import { useHistory } from 'react-router'

const useStyles = makeStyles(styles, { name: 'DocumentationButton' })

function DocumentationButton () {
  const classes = useStyles()

  const history = useHistory()

  const openDocumentation = () => {
    history.push(LINKS.MAIN.DOCUMENTATION.path)
  }

  return (
    <Button
      className={classes.main}
      onClick={openDocumentation}
    >
      <FormattedMessage id='documentation' defaultMessage='Documentation' />
    </Button>
  )
}

export default DocumentationButton
